import React from "react";
import { adminTokenCookieName, envs } from "./constants";
import axios from "axios";
import Cookies from "js-cookie";

export interface CustomLandingResponse {
    page: CLandingPage;
    data: CustomLandingItem[];
}

export interface CustomLandingItem {
    _id: string;
    name: string;
    description?: string;
    slug: string;
    images: string;
    settings: any;
    shopId: number;
    status: number;
    deletedAt: null;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface CLandingPage {
    totalIndex: number;
    totalPage: number;
    currentPage: number;
    nextPage: null;
    previousPage: null;
    startingIndex: number;
    endingIndex: number;
    itemsOnCurrentPage: number;
    limit: number;
    sortBy: string;
    sortOrder: number;
}

export interface CustomLandingType {
    name: string;
    images: string;
    description?: string;
    settings: any;
    createdAt?: string;
}

export const getCustomLandingPagesGlobal = ({
    perPage = 10,
    currentPage = 1,
    status = 1,
}): Promise<CustomLandingResponse> => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await axios.get(
                `${envs.frontendApiUrl}landing-theme/public?perPage=${perPage}&currentPage=${currentPage}&status=${status}`,
                {
                    headers: {
                        Authorization: `Bearer ${Cookies.get(
                            adminTokenCookieName
                        )}`,
                    },
                }
            );

            resolve(res.data);
        } catch (error) {
            reject(error);
        }
    });
};

export const addCustomLandingGlobal = (
    data: CustomLandingType
): Promise<CustomLandingType> => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await axios.post(
                `${envs.frontendApiUrl}landing-theme`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${Cookies.get(
                            adminTokenCookieName
                        )}`,
                    },
                }
            );

            resolve(res.data);
        } catch (error) {
            reject(error);
        }
    });
};

// /api/v1/landing-theme/:id
export const getCustomLandingTheme = (
    id: string | number
): Promise<CustomLandingItem> => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await axios.get(
                `${envs.frontendApiUrl}landing-theme/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${Cookies.get(
                            adminTokenCookieName
                        )}`,
                    },
                }
            );

            resolve(res.data?.data);
        } catch (error) {
            reject(error);
        }
    });
};

// PATCH: /landing-theme/:id
export const updateCustomLandingTheme = (
    id: string | number,
    data: any
): Promise<CustomLandingItem> => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await axios.patch(
                `${envs.frontendApiUrl}landing-theme/${id}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${Cookies.get(
                            adminTokenCookieName
                        )}`,
                    },
                }
            );

            resolve(res.data?.data);
        } catch (error) {
            reject(error);
        }
    });
};
